export const en = {
  translation: {
    "Belimo Energy Valve": "Belimo Energy Valve",
    Yes: "Yes",
    No: "No",
    "You cannot go back from this position":
      "You cannot go back from this position",
    Chapters: "Chapters",
    Start: "Start",
    "Connecting to the Energy Valve":
      "Connecting to the Energy Valve",
    "Control Source": "Control Source",
    "Do you know the design flow rate?":
      "Do you know the design flow rate?",
    "Flow Control": "Flow Control",
    "Is the building running off fixed or varying flow temperatures?":
      "Is the building running off fixed or varying flow temperatures?",

    "Varying flow temperatures (Delta T Manager Scaling)":
      "Varying flow temperatures (Delta T Manager Scaling)",

    "Fixed flow temperatures (Delta T Manager)":
      "Fixed flow temperatures (Delta T Manager)",
    "I am not sure": "I am not sure",
    "Delta T Manager": "Delta T Manager",
    Scaling: "Scaling",
    "Do you know the power output?":
      "Do you know the power output?",
    "Yes (Power Control)": "Yes (Power Control)",
    "No (Position Control)": "No (Position Control)",
    "Power Control": "Power Control",
    "Position Control": "Position Control",
    "Onboard Data Analysis": "Onboard Data Analysis",
    "Did you get a clear result from the Energy Valve?":
      "Did you get a clear result from the Energy Valve?",
    "How do you want to setup your Energy Valve?":
      "How do you want to setup your Energy Valve?",
    "Would you like to connect to the cloud?":
      "Would you like to connect to the cloud?",
    "Cloud Connectivity": "Cloud Connectivity",
    "Onboard Diagnostics / Download Data":
      "Onboard Diagnostics / Download Data",
    "Download Data": "Download Data",
    "Send optimization request":
      "Send optimization request",
    End: "End",

    Subtitles: "Subtitles",
    Repeat: "Repeat",
    Continue: "Continue",
  },
};
